import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  standalone: false,
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent implements AfterViewInit, OnInit, OnDestroy {
  isMobileMenuOpen = false;
  activeModal: 'login' | 'signup' | 'contact' | null = null;
  messageText = '';
  isMessageVisible = false;

  constructor(private router: Router) { }

  ngOnInit() {
    document.documentElement.style.setProperty('font-size', '16px', 'important');
    document.documentElement.style.setProperty('scroll-behavior', 'smooth', 'important');
  }

  ngOnDestroy() {
    document.documentElement.style.removeProperty('font-size');
    document.documentElement.style.removeProperty('scroll-behavior');
  }

  ngAfterViewInit(): void {
    if ((window as any)['lucide']) {
      (window as any)['lucide'].createIcons();
    }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  hideMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  showModal(type: 'login' | 'signup' | 'contact') {
    this.activeModal = type;
  }

  hideModal() {
    this.activeModal = null;
  }

  get modalTitle() {
    if (this.activeModal === 'login') { return 'Log In to Your Account'; }
    if (this.activeModal === 'contact') { return 'Enterprise Contact'; }
    return 'Sign Up for AnTim GPS';
  }

  showMessage(text: string) {
    this.messageText = text;
    this.isMessageVisible = true;
    setTimeout(() => {
      this.isMessageVisible = false;
    }, 3000);
  }

  onSubmitSignup(event: Event, email: string) {
    event.preventDefault();
    this.hideModal();
    this.showMessage(`Success! Account created for ${email}. Redirecting to dashboard...`);
  }

  onSubmitLogin(event: Event, email: string) {
    event.preventDefault();
    this.hideModal();
    this.showMessage(`Welcome back, ${email}! Logging in...`);
  }

  scrollToSection(event: Event, sectionId: string) {
    event.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    this.hideMobileMenu();
  }

  goToLogin() {
    const token = localStorage.getItem('access_token');
    let targetPath = ['/authentication/login'];

    if (token) {
      targetPath = ['/application/dashboard'];
    }
    const url = this.router.serializeUrl(
      this.router.createUrlTree(targetPath)
    );
    window.open(url, '_blank');
  }
}